module.exports = __webpack_public_path__ + "static/media/capacitorjs.f406481a.svg";